// extracted by mini-css-extract-plugin
export default {"tableWrapper":"CityAliasesByProviderPage_tableWrapper__BxGz2","toolbar":"CityAliasesByProviderPage_toolbar__OMGoc","filter":"CityAliasesByProviderPage_filter__Xy6Wx"};